var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemInfoWrapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.25V26C28 29 26.21 30 24 30H16C13.79 30 12 29 12 26V16.25C12 13 13.79 12.25 16 12.25C16 12.87 16.25 13.43 16.66 13.84C17.07 14.25 17.63 14.5 18.25 14.5H21.75C22.99 14.5 24 13.49 24 12.25C26.21 12.25 28 13 28 16.25Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.25C24 13.49 22.99 14.5 21.75 14.5H18.25C17.63 14.5 17.07 14.25 16.66 13.84C16.25 13.43 16 12.87 16 12.25C16 11.01 17.01 10 18.25 10H21.75C22.37 10 22.93 10.25 23.34 10.66C23.75 11.07 24 11.63 24 12.25Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21H20",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25H24",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemInfoWrapper);
export default __webpack_public_path__ + "static/media/system-info-wrapper.4ba3165c29cdf9335f9e8d96a98767e5.svg";
export { ForwardRef as ReactComponent };